import { GTM } from "./GTMInterfaces";
import { GTMOnceForSession } from "./GTMOnceForSession";
import { isEventOnceForSession } from "./isOnceForSession";

export function existEventOnceInSession(event: GTM.EventExtendend): boolean {
  return isEventOnceForSession(event) && GTMOnceForSession.exist(event.event);
}
